module.exports = __webpack_public_path__ + "img/molmer-sorensen-dagger.a7ada580.svg";